import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_components/AboutPreview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_components/GithubCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_components/HomeTop.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/ContactModal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/projects/_components/Project.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_components/Home.module.css");
